import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/valueClinicalEvaluation/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/valueClinicalEvaluation/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/valueClinicalEvaluation/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/valueClinicalEvaluation/save', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/valueClinicalEvaluation/update', params,options)

export const getClinicalEvaluation = (params, options) =>
  request.post('/api/v4ward/valueClinicalEvaluation/getClinicalEvaluation', params,options)

// 供应商列表
export const getPartnerList = (params, options) =>
  request.get('/api/v4ward/partner/partnerlist', Object.assign({}, options, { params }));
